import { render, staticRenderFns } from "./citizen-action.vue?vue&type=template&id=69ec9256&scoped=true&lang=pug&"
import script from "./citizen-action.vue?vue&type=script&lang=js&"
export * from "./citizen-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ec9256",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
